import { createSlice } from "@reduxjs/toolkit";
import { foundationDetailsService } from "Services/FoundationDetailsService";

export const initialState = {
    loadingList: false,
    selectedUsIndex: '',
    pagedList: {
        pageNumber: 0,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0,
        orderField: 'createdAt',
        orderDirection: 'desc',
        updateType: '',
        items: []
    },
    findFunderDialog: {
        open: false,
        source: 'IRS',
        profileId: '',
        error: ''
    }
};

const manageFoundationsSlice = createSlice({
    name: "manage-foundations",
    initialState,
    reducers: {
        handleOpenFindFunderDialog: (state) => {
            state.findFunderDialog = initialState.findFunderDialog;
            state.findFunderDialog.open = true;
        },
        handleCloseFindFunderDialog: (state) => {
            state.findFunderDialog = initialState.findFunderDialog;
        },
        handleChangeFindFunderField: (state, action) => {
            state.findFunderDialog[action.payload.field] = action.payload.value;
            state.findFunderDialog.error = '';
        },
        handleChangeSelectedIndex: (state, action) => {
            state.selectedUsIndex = action.payload;
        },
        handleChangeUpdateTypeFilter: (state, action) => {
            state.pagedList.updateType = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            foundationDetailsService.endpoints.getUpdateRequestPagedList.matchFulfilled, (state, action) => {
                state.loadingList = false;
                state.pagedList.pageNumber = action.payload.pageNumber;
                state.pagedList.pageSize = action.payload.pageSize;
                state.pagedList.pageCount = action.payload.pageCount;
                state.pagedList.totalCount = action.payload.totalCount;
                state.pagedList.orderField = action.payload.orderField;
                state.pagedList.orderDirection = action.payload.orderDirection;
                state.pagedList.items = action.payload.items;
            }
        )
        .addMatcher(
            foundationDetailsService.endpoints.getUpdateRequestPagedList.matchPending, (state) => {
                state.loadingList = true;
            }
        )
        .addMatcher(
            foundationDetailsService.endpoints.getUpdateRequestPagedList.matchRejected, (state) => {
                state.loadingList = false;
            }
        )
    }
});

export const {
    handleOpenFindFunderDialog,
    handleCloseFindFunderDialog,
    handleChangeFindFunderField,
    handleChangeSelectedIndex,
    handleChangeUpdateTypeFilter,
} = manageFoundationsSlice.actions;

export default manageFoundationsSlice.reducer;
